var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteIcon = function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF75CB",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M33 9V7a6 6 0 0 0-6-6h-8a6 6 0 0 0-6 6v2M1 9h44M29 21v10M17 21v10M5 9h36l-1.325 26.5a10 10 0 0 1-9.987 9.5H16.313a10 10 0 0 1-9.988-9.5z"
  })));
};
export default SvgDeleteIcon;